import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/_app'
// import './index.css';


// Safely check for electron context
// const isElectron = window && window.process && window.process.type === 'renderer'

// if (isElectron) {
//   const ipc = window.require('electron').ipcRenderer
//   ipc.on('all-keys-ready', () => {
//     console.log('all keys readied!', process.pid, window.process.pid, process.env.REACT_APP_APP_URL)
//     // process.env = {...process.env, ...window.process.env}
//     // for(let key of Object.keys(window.process.env)) process.env[key] = window.process.env[key] 
//     const container = document.getElementById('root')
//     const root = createRoot(container)
//     root.render(<App />)
//   })
// } else {
  // For non-electron environment (e.g. web browser)
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(<App />)
// }
